import React from "react";
import { useNavigate } from "react-router-dom";
import { OM_LOGO, MTN_LOGO } from "../assets/logos";
import Card, { SectionLabel } from "../components/ui/Card";
import { fmt } from "../utils/helpers";

const RECENT = [
  { type: "credit", label: "Crédit Orange", sub: "699 XXX 123 → 655 XXX 456 · 14 mars · 09:41", amount: -1000 },
  { type: "transfer", label: "Transfert OM→MTN", sub: "699 XXX 789 → 677 XXX 012 · 12 mars · 14:23", amount: -5000 },
];

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="bg-[#f0f2f7] pb-2 screen-enter">
      {/* Header */}
      <div className="bg-brand-orange px-[17px] pt-[17px] pb-[26px]">
        <div className="flex justify-between items-center mb-3">
          <div className="flex items-center gap-1.5">
            <div className="w-7 h-7 bg-white rounded-lg flex items-center justify-center">
              <i className="fa fa-exchange-alt text-brand-orange" style={{ fontSize: 10 }} />
            </div>
            <span className="text-white text-[18px] font-black tracking-widest">DiWAD</span>
          </div>
          <div className="w-[30px] h-[30px] rounded-full bg-white/20 flex items-center justify-center">
            <i className="fa fa-bell text-white" style={{ fontSize: 12 }} />
          </div>
        </div>
        <p className="text-white/80 text-xs mb-0.5">Bonjour,</p>
        <h2 className="text-white text-xl font-bold">Jean-Paul Nkomo</h2>
      </div>

      <div className="px-[13px] mt-[-18px]">
        {/* Balance card */}
        <Card className="mb-3">
          <SectionLabel className="mb-1">Solde total disponible</SectionLabel>
          <p className="text-[26px] font-extrabold text-brand-dark mb-3 tracking-tight">
            58 000 <span className="text-sm font-normal text-gray-400">FCFA</span>
          </p>
          <div className="grid grid-cols-2 gap-2">
            <div className="bg-brand-orange-light rounded-[10px] p-2.5 border border-brand-orange-border">
              <img src={OM_LOGO} alt="Orange Money" className="h-[18px] mb-1.5 block" />
              <p className="text-xs font-bold text-brand-dark">
                45 200 <span className="text-[10px] font-normal text-gray-400">FCFA</span>
              </p>
            </div>
            <div className="bg-brand-blue-light rounded-[10px] p-2.5 border border-brand-blue-border">
              <img src={MTN_LOGO} alt="MTN MoMo" className="h-[18px] mb-1.5 block" />
              <p className="text-xs font-bold text-brand-dark">
                12 800 <span className="text-[10px] font-normal text-gray-400">FCFA</span>
              </p>
            </div>
          </div>
        </Card>

        {/* Quick actions */}
        <SectionLabel>Actions rapides</SectionLabel>
        <div className="grid grid-cols-2 gap-[9px] mb-3">
          <button
            onClick={() => navigate("/credit")}
            className="bg-brand-orange text-white p-[13px] flex flex-col items-start gap-1.5 rounded-[14px] w-full cursor-pointer border-none tap-highlight active:opacity-75 transition-opacity"
          >
            <div className="w-[30px] h-[30px] bg-white/20 rounded-lg flex items-center justify-center">
              <i className="fa fa-mobile-alt text-white" style={{ fontSize: 13 }} />
            </div>
            <div>
              <p className="text-[11px] text-white/80 text-left">Acheter du</p>
              <p className="text-[13px] font-bold text-left">Crédit</p>
            </div>
          </button>
          <button
            onClick={() => navigate("/transfer")}
            className="bg-brand-blue text-white p-[13px] flex flex-col items-start gap-1.5 rounded-[14px] w-full cursor-pointer border-none tap-highlight active:opacity-75 transition-opacity"
          >
            <div className="w-[30px] h-[30px] bg-white/20 rounded-lg flex items-center justify-center">
              <i className="fa fa-exchange-alt text-white" style={{ fontSize: 12 }} />
            </div>
            <div>
              <p className="text-[11px] text-white/80 text-left">Transfert</p>
              <p className="text-[13px] font-bold text-left">Orange ↔ MTN</p>
            </div>
          </button>
        </div>

        {/* Recent */}
        <SectionLabel>Récent</SectionLabel>
        <Card padding={false}>
          {RECENT.map((tx, i) => (
            <div
              key={i}
              className={`px-3 py-2.5 flex items-center gap-[9px] ${i < RECENT.length - 1 ? "border-b border-gray-100" : ""}`}
            >
              <div
                className={`w-8 h-8 rounded-[9px] flex items-center justify-center flex-shrink-0 ${tx.type === "credit" ? "bg-brand-orange-light" : "bg-brand-blue-light"}`}
              >
                <i
                  className={`fa ${tx.type === "credit" ? "fa-mobile-alt text-brand-orange" : "fa-exchange-alt text-brand-blue"}`}
                  style={{ fontSize: 12 }}
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs font-semibold text-brand-dark">{tx.label}</p>
                <p className="text-[10px] text-gray-400 truncate">{tx.sub}</p>
              </div>
              <span className="text-xs font-bold text-brand-danger flex-shrink-0">
                -{fmt(tx.amount)}
              </span>
            </div>
          ))}
        </Card>
      </div>
    </div>
  );
}
